<template>
  <div>
    <div>非選択</div>
    <FilterModule :is-filtered="false" @clicked="onClick" />
    <div>選択中</div>
    <FilterModule :is-filtered="true" @clicked="onClick" />
  </div>
</template>
<script>
import FilterModule from '../../components/atoms/filters/FilterModule.vue'
export default {
  components: { FilterModule },
  methods: {
    onClick() {
      alert('clicked filter!')
    }
  }
}
</script>
